module.exports = __webpack_public_path__ + "Poppins-MediumItalic.610b5f302ccd5af9290e.woff";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Poppins-MediumItalic.woff
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Poppins-MediumItalic.woff
// module chunks = styles